import React from "react";
import type { StatusFilter } from "../../hooks/useLocationFilters";

const FILTERS: {
  key: StatusFilter;
  label: string;
  dot: string;
  cls: string;
  activeCls: string;
}[] = [
  { key: "all",                 label: "Toutes",         dot: "bg-slate-400",   cls: "text-slate-600",   activeCls: "bg-slate-700 text-white border-slate-700" },
  { key: "active",              label: "Actives",        dot: "bg-emerald-400", cls: "text-emerald-700", activeCls: "bg-emerald-600 text-white border-emerald-600" },
  { key: "suspended",           label: "Suspendues",     dot: "bg-rose-400",    cls: "text-rose-700",    activeCls: "bg-rose-600 text-white border-rose-600" },
  { key: "needsReverification", label: "Revérification", dot: "bg-amber-400",   cls: "text-amber-700",   activeCls: "bg-amber-500 text-white border-amber-500" },
  { key: "unpublished",         label: "Non publiées",   dot: "bg-slate-300",   cls: "text-slate-500",   activeCls: "bg-slate-500 text-white border-slate-500" },
  { key: "unverified",          label: "Non vérifiées",  dot: "bg-orange-400",  cls: "text-orange-700",  activeCls: "bg-orange-500 text-white border-orange-500" },
];

interface Props {
  counts: Record<StatusFilter, number>;
  active: StatusFilter;
  onChange: (f: StatusFilter) => void;
  enriching?: boolean;
}

export const StatusFilterBar: React.FC<Props> = ({
  counts,
  active,
  onChange,
  enriching,
}) => (
  <div className="flex flex-wrap gap-1.5 items-center">
    {FILTERS.map((f) => {
      const isActive = active === f.key;
      const count    = counts[f.key];

 
      return (
        <button
          key={f.key}
          onClick={() => onChange(f.key)}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[11px] font-semibold
            border transition-all duration-150 cursor-pointer
            ${
              isActive
                ? `${f.activeCls} shadow-sm`
                : `bg-white border-slate-200 hover:border-slate-300 ${f.cls}`
            }`}
        >
          <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${f.dot}`} />
          {f.label}
          <span
            className={`px-1.5 py-0.5 rounded-full text-[10px] font-bold leading-none
              ${isActive ? "bg-white/25 text-white" : "bg-slate-100 text-slate-500"}`}
          >
            {enriching && f.key !== "all" ? "…" : count}
          </span>
        </button>
      );
    })}

    {enriching && (
      <span className="text-[10px] text-slate-400 animate-pulse ml-1">
        Enrichissement…
      </span>
    )}
  </div>
);